<template>
	<div class="release_sdk">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">释放SDK资源</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			如果无需继续使用SDK相关接口，可调用该接口释放资源，如需再次使用需重新初始化。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceReleaseSDK() </code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">无</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">无</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">skFaceSDKFamily.SKFaceReleaseSDK();</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceFamily-Android','基础接口','释放SDK资源'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.release_sdk{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/SKFaceSDKFamily/basics/SKFacesdkfamilyReleaseSDK.vue